import { useEffect, useState } from "react";

import { useMultiAgentStore } from "@/stores/multiAgentStore";

// Playful, on-brand ("Weave") lines shown during the quiet warm-up — before any
// planning/narration arrives — so a live run never feels dead/stuck. Rendered as
// shimmer-TEXT (a gradient sweeps the glyphs) INSIDE the skeleton block so it
// blends with the shimmer instead of sitting as a separate line below it. Hands
// the space over to <Narration> the moment real reasoning flows.
const WEAVE_LINES = [
  "Let's weave…",
  "Stitching the threads…",
  "Threading the needle…",
  "Finding the thread…",
  "Warping the loom…",
  "Picking up the pattern…",
  "Tying off loose ends…",
];

export function WeaveShimmerCaption() {
  const reasoningBuffer = useMultiAgentStore((s) => s.reasoningBuffer);
  const nodes = useMultiAgentStore((s) => s.nodes);
  const [i, setI] = useState(0);

  const hasNarration =
    Object.values(reasoningBuffer).some((t) => (t || "").trim().length > 0) ||
    Object.values(nodes).some(
      (n) => n.status === "running" || n.status === "tool_calling",
    );

  useEffect(() => {
    if (hasNarration) return;
    const t = setInterval(() => setI((n) => (n + 1) % WEAVE_LINES.length), 2200);
    return () => clearInterval(t);
  }, [hasNarration]);

  if (hasNarration) return null;

  return (
    <div
      className="ma-weave-shimmer"
      aria-live="polite"
      style={{ fontSize: 13, fontWeight: 500, letterSpacing: "0.01em", lineHeight: "18px" }}
    >
      {WEAVE_LINES[i]}
    </div>
  );
}
